import { faInfo, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { ErrorMessage, getIn, useFormikContext } from 'formik';
import React from 'react';
import { Button, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CreateApplicationFormValues } from '../../views/ApplicationCreate';

export interface Props {
  index: number;
}

const ApplicationJobCreate = ({ index }: Props): React.ReactElement => {
  const { t } = useTranslation(['createApplication', 'common']);
  const { values, errors, touched, getFieldProps, setFieldValue } = useFormikContext<CreateApplicationFormValues>();

  return (
    <div>
      <Row>
        <Col md={6}>
          <Form.Group controlId={`job[${index}].job`}>
            <Form.Label>
              <OverlayTrigger placement="right-end" overlay={<Tooltip id="tooltip-courses">{t('JobInfo')}</Tooltip>}>
                <div>
                  {t('job')}*: <FontAwesomeIcon icon={faInfo} />
                </div>
              </OverlayTrigger>
            </Form.Label>{' '}
            {values.job.length > 1 && (
              <Button
                className="p-0 iconColorRed"
                variant="link"
                onClick={() => {
                  setFieldValue(
                    'job',
                    values.job.filter((_, i) => i !== index)
                  );
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            )}
            <Form.Control
              type="text"
              className={classNames({
                'is-invalid': getIn(touched, `job[${index}].job`) && getIn(errors, `job[${index}].job`),
              })}
              {...getFieldProps(`job[${index}].job`)}
            />
            <ErrorMessage name={`job[${index}].job`} component="div" className="invalid-feedback d-block text-left" />{' '}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId={`job[${index}].company`}>
            <Form.Label>{t('company')}*:</Form.Label>
            <Form.Control
              type="text"
              className={classNames({
                'is-invalid': getIn(touched, `job[${index}].company`) && getIn(errors, `job[${index}].company`),
              })}
              {...getFieldProps(`job[${index}].company`)}
            />
            <ErrorMessage name={`job[${index}].company`} component="div" className="invalid-feedback d-block text-left" />{' '}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group controlId={`job[${index}].description`}>
            <Form.Label>
              <OverlayTrigger placement="right-end" overlay={<Tooltip id="tooltip-courses">{t('jobDescriptionInfo')}</Tooltip>}>
                <div>
                  {t('description')}: <FontAwesomeIcon icon={faInfo} />
                </div>
              </OverlayTrigger>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              type="text"
              className={classNames({
                'is-invalid': getIn(touched, `job[${index}].description`) && getIn(errors, `job[${index}].description`),
              })}
              {...getFieldProps(`job[${index}].description`)}
            />
          </Form.Group>
        </Col>
      </Row>
      <hr />
    </div>
  );
};
export default ApplicationJobCreate;
